module.exports = __webpack_public_path__ + "static/media/pix_logo.de0aa9e5.png";